import React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import CourseCard from "../Components/CourseCard/CourseCard";
import "../Components/CourseCard/CourseCard.css"; // STYLES - pow wow - you beaut
import Overlay from "../Components/CourseCard/Overlay"; // Overlay hopefully works
// import F1Car from "../Components/CourseCard/f1Anim";
import DownArrow from "../Components/CourseCard/DownArrow"; // going down down down down
import FloatingPointsBackground from "../Components/FloatingPoints/FloatingPoints";
import { Box, Grid, Typography, Container } from "@mui/material";
import Aurora from "../Components/Homepage/Aurora/Aurora"; // Aurora component for background effect
import BouncingCTA from "../Components/BouncingButton/BouncingCTA";


const Education = () => {
    const [courses, setCourses] = useState([]);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [showPage, setShowPage] = useState(false);

    useEffect(() => {
        fetch("https://dun.vydeo.xyz/iter3/courses", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`, //
                "Content-Type": "application/json", // 
            },
        })
            .then((response) => response.json())
            .then((data) => setCourses(data))
            .catch((error) => console.error("Error fetching courses:", error));
    }, []);


    return (
        <>
            <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                    pointerEvents: 'none',
                }}
            >
                <Aurora
                    colorStops={["#3A09AF", "#AF243A", "#FF3232"]}
                    blend={0.9}
                    amplitude={1.0}
                    speed={1.5}
                />
            </Box>

            <Box
                sx={{
                    position: 'relative',
                    backgroundImage: 'linear-gradient(to bottom right,rgba(3, 77, 47, 0.36),rgba(104, 27, 3, 0.38))',
                    zIndex: 1,
                }}
            >

                {/* <FloatingPointsBackground /> */}
                {!showPage && (
                    <motion.div
                        className="f1-container"
                        initial={{ opacity: 1 }}
                        animate={{ opacity: 0 }}
                        transition={{ delay: 1, duration: 2 }}
                        onAnimationComplete={() => setShowPage(true)} // Show page after animation
                    >
                        <motion.img
                            src="/images/F1_car_test.png"
                            alt="F1 Car"
                            className="f1-car"
                            initial={{ x: "-100vw" }}
                            animate={{ x: "100vw" }}
                            transition={{ duration: 2.5, ease: "easeInOut" }}
                        />
                    </motion.div>
                )}
                <motion.div
                    className={"education-container"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                >
                    <Typography variant="h3" component="h1" sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center', marginTop: '40px' }}>
                        Explore Our Courses
                    </Typography>
                    <br />
                    <br />
                    <br />
                    <Typography variant="h5" component="h2" sx={{ color: 'white' }}>
                        Misinformation isn’t harmless — it distorts facts, fuels fear, and divides communities. Our courses help you recognize, question, and respond to it so you can stay informed, not misled.
                    </Typography>

                    <motion.div
                        className="courses-grid"
                        initial={{ y: 50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 1 }}
                    >
                        {courses.map((course) => (
                            <CourseCard
                                key={course.id}
                                course={course}
                                isSelected={selectedCourse === course.id}
                                onSelect={setSelectedCourse}
                            />
                        ))}
                    </motion.div>
                    {selectedCourse &&
                        <Overlay
                            course={courses.find(c => c.id === selectedCourse)}
                            onClose={() => setSelectedCourse(null)}
                        />}
                    {/* Overlay component to show course details */}
                    {/* Misinformation text section */}

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'stretch',
                            gap: 4, // spacing between cards
                            flexWrap: 'wrap', // allow wrapping on smaller screens
                            mt: 4, // top margin
                        }}
                    >
                        <BouncingCTA
                            text="Dive into the game and put your knowledge to the test and Defeat ECHO!"
                            link="/defence-game"
                            linkText="Play the Game"
                            bgImage="/images/navcards/gameplay.png"
                        />

                        <BouncingCTA
                            text="Think you're a misinformation expert? Prove it by taking our challenge quiz!"
                            link="/quiz"
                            linkText="Take the challenge"
                            bgImage="/images/navcards/quiz_news.png"
                        />
                        {/* <BouncingCTA
                            text="Your central hub for all things related to building digital trust!"
                            link="/dashboard"
                            linkText="Go to My Dashboard"
                            bgImage="/images/navcards/dashboard.png"
                        /> */}
                    </Box>
                </motion.div>
                <DownArrow />
            </Box>
        </>
    );
};


export default Education;
